var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      staticStyle: { "margin-left": "5px" },
      attrs: { slot: "reference", size: "small", type: "warning" },
      on: { click: _vm.handleSubmit },
      slot: "reference",
    },
    [_vm._v("批量审核付款")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }